module.exports = __webpack_public_path__ + "images/pages/lp/user_1_9a632264ef8c5eea8948aff23032b571.png";